export function DashboardCardSkeleton() {
  return (
    <div className="animate-pulse rounded-2xl border border-gray-100 bg-white p-5 shadow-sm">
      <div className="flex items-start justify-between gap-4">
        <div className="flex flex-1 flex-col gap-3">
          <div className="h-4 w-28 rounded bg-gray-200" />
          <div className="h-9 w-20 rounded bg-gray-300" />
        </div>
        <div className="h-12 w-12 shrink-0 rounded-xl bg-gray-200" />
      </div>
    </div>
  );
}
